module.exports = __webpack_public_path__ + "static/media/baseLiquida.5cbf4588.jpeg";